export default __webpack_public_path__ + "static/gplay_ja-86d52c7d3d63b1bba826e12261920bf8.png";